import React from 'react';
import { useFormContext } from '../../components/FormContext';


const BankInfoSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFieldValue,
    setFormErrors, 
    setModifiedFields
  } = useFormContext();

const validateNumber = (field, e) => {
  const value = e.target.value.replace(/\D/g, '');
  setFieldValue('bankAccountNumber', value);
  setModifiedFields(prev => new Set([...prev, field]));

  let error = null;
  if (value.trim() === '') {
    error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
  } else {
    const cleanNum = value.replace(/\s/g, '');
    if (!/^\d+$/.test(cleanNum)) {
      error = 'Account number must contain only numbers';
    } else if (cleanNum.length < 6 || cleanNum.length > 10) {
      error = 'Account number must be between 6 and 10 digits';
    }
  }

  if (error) {
    setFormErrors(prev => ({ ...prev, [field]: error }));
  } else {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[field];
      return newErrors;
    });
  }
};



const validateBSB = (field, e) => {
  let raw = e.target.value.replace(/\D/g, '').slice(0, 6);

  let formatted = raw;
  if (raw.length > 3) {
    formatted = raw.slice(0, 3) + '-' + raw.slice(3);
  }

  setFieldValue('bsbNumber', formatted);
  setModifiedFields(prev => new Set([...prev, field]));

  let error = null;
  if (formatted.trim() === '') {
    error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
  } else if (!/^\d{3}-\d{3}$/.test(formatted)) {
    error = `${field.charAt(0).toUpperCase() + field.slice(1)} must be in format XXX-XXX`;
  }

  if (error) {
    setFormErrors(prev => ({ ...prev, [field]: error }));
  } else {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[field];
      return newErrors;
    });
  }
};


const handleTextChange = (field, e) => {
    const value = e.target.value;
    setFieldValue(field, value);
    setModifiedFields(prev => new Set([...prev, field]));
    
    let error = null;
    if (value.trim() === '') {
     
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else if (/\d/.test(value)) {

      error = `${field.charAt(0).toUpperCase() + field.slice(1)} should not contain numbers`;

    }
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };


  return (
<div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Bank Information</h4>
        <div className="space-y-4">
        <div>
        <label htmlFor="bank-account-name" className="block text-sm font-medium text-gray-700 mb-1">
                    Bank Account Name
                  </label>
                  <input
                    type="text"
                    id="bank-account-name"
                    name="bankAccountName"
                    value={formData.bankAccountName}
                    onChange={(e) => handleTextChange('bankAccountName', e)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  />
                  
                  {formErrors.bankAccountName && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('bankAccountName') && (
                    <div className="text-sm text-red-600 mt-1">
                      {formErrors.bankAccountName}
                    </div>
                  )}
              
                </div>
        
                <div>
                
                  <label htmlFor="bsb-number" className="block text-sm font-medium text-gray-700 mb-1">
                    BSB Number (###-###)
                  </label>
                  <input
                    type="text"
                    inputMode='numeric'
                    maxLength={7}
                    id="bsb-number"
                    name="bsbNumber"
                    value={formData.bsbNumber}
                    onChange={(e) => validateBSB('bsbNumber', e)}
                    placeholder="000-000"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  />
                  
                  {formErrors.bsbNumber && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('bsbNumber') && (
                    <div className="text-sm text-red-600 mt-1">
                      {formErrors.bsbNumber}
                    </div>
                  )}
               
                </div>
        
                <div>
                
                  <label htmlFor="bank-account-number" className="block text-sm font-medium text-gray-700 mb-1">
                    Bank Account Number
                  </label>
                  <input
                    type="text"
                    inputMode='numeric'
                    maxLength={10}
                    id="bank-account-number"
                    name="bankAccountNumber"
                    value={formData.bankAccountNumber}
                    onChange={(e) => validateNumber('bankAccountNumber', e)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  />
                  
                  {formErrors.bankAccountNumber && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('bankAccountNumber') && (
                    <div className="text-sm text-red-600 mt-1">
                      {formErrors.bankAccountNumber}
                    </div>
                  )}
                </div>
              </div>
              </div>





    );
};

export default BankInfoSection;